import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function OutliersPanel() {

    const [open, setOpen] = useState(true);

    const outliers = [
        {
            type: "User",
            label: "Sarah Jones",
            message: "Scores diverge sharply from department average",
            severity: "high"
        },
        {
            type: "Question",
            label: "Desk IT Setup",
            message: "Variance 2.8σ above normal range",
            severity: "high"
        },
        {
            type: "Response",
            label: "Response #3943",
            message: "Completed in 42 seconds (avg 21m)",
            severity: "medium"
        },
        {
            type: "User",
            label: "Mike Brown",
            message: "Highly inconsistent scoring pattern",
            severity: "medium"
        },
        {
            type: "Question",
            label: "Meeting Space Booking",
            message: "Sudden drop in satisfaction",
            severity: "high"
        }
    ];

    const styles = {

        container: {
            position: "fixed",
            top: "60px",
            right: open ? "0" : "-315px",
            width: "300px",
            height: "calc(100% - 60px)",
            background: "linear-gradient(180deg, #0f0f12 0%, #1a1a1f 100%)",
            color: "#fff",
            padding: "16px",
            boxShadow: "-4px 0 12px rgba(0,0,0,0.3)",
            zIndex: 100,
            display: "flex",
            flexDirection: "column",
            transition: "right 0.3s ease",
            borderTopLeftRadius: "14px",
            borderBottomLeftRadius: "14px"
        },

        toggleButton: {
            position: "absolute",
            left: "-18px",
            top: "calc(50vh - 100px)",
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            backgroundColor: "#111",
            border: "2px solid #333",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.6)",
            color: "#fff",
            zIndex: 101
        },

        header: {
            fontSize: "14px",
            fontWeight: 700,
            marginBottom: "12px",
            color: "#fff"
        },

        subtitle: {
            fontSize: "11px",
            color: "#aaa",
            marginBottom: "10px"
        },

        list: {
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            overflowY: "auto"
        },

        item: {
            backgroundColor: "#18181d",
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            cursor: "pointer",
            transition: "background 0.2s ease"
        },

        severityDot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            marginTop: "4px",
            flexShrink: 0
        },

        severityHigh: {
            backgroundColor: "#e53935",
            boxShadow: "0 0 6px rgba(229,57,53,0.8)"
        },

        severityMedium: {
            backgroundColor: "#ffb300",
            boxShadow: "0 0 6px rgba(255,179,0,0.7)"
        },

        textBlock: {
            display: "flex",
            flexDirection: "column",
            gap: "2px"
        },

        label: {
            fontSize: "12px",
            fontWeight: 600,
            color: "#fff"
        },

        type: {
            fontSize: "10px",
            color: "#888"
        },

        message: {
            fontSize: "11px",
            color: "#bbb",
            lineHeight: "1.4em"
        },

        footer: {
            marginTop: "auto",
            fontSize: "10px",
            color: "#777",
            textAlign: "center",
            paddingTop: "10px"
        }
    };

    return (
        <div style={styles.container}>

            {/* Toggle Button */}
            <div style={styles.toggleButton} onClick={() => setOpen(!open)}>
                <FontAwesomeIcon icon={open ? faChevronRight : faChevronLeft} />
            </div>

            <div style={styles.header}>Outliers</div>

            <div style={styles.subtitle}>
                Anomalies detected in users, responses and answers
            </div>

            <div style={styles.list}>
                {outliers.map((item, index) => (
                    <div
                        key={index}
                        style={styles.item}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = "#202028"}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = "#18181d"}
                        title="Click to navigate"
                    >
                        <div
                            style={{
                                ...styles.severityDot,
                                ...(item.severity === "high"
                                    ? styles.severityHigh
                                    : styles.severityMedium)
                            }}
                        />

                        <div style={styles.textBlock}>
                            <div style={styles.label}>{item.label}</div>
                            <div style={styles.type}>{item.type}</div>
                            <div style={styles.message}>{item.message}</div>
                        </div>
                    </div>
                ))}
            </div>

            <div style={styles.footer}>
                OmniScan – Intelligent Detection
            </div>

        </div>
    );
}
